import {
  normalizePrintPlanGroupKeys,
  printPlanGroupSelectionSignature
} from './print_plan_group_filter_model.mjs?v=20260904c';

// Capture-in-progress guard for the print-preview modal's one-shot plan
// snapshot (see print_plan_render.js#captureLivePlanSnapshot). Structural
// twin of bom_plan_context.js's capture-flag part — kept separate (rather
// than reusing that module) because this feature never sets a BOM-style
// scope-selection map, so isBomPlanRendering() must stay false during our
// capture and the full, unfiltered plan (obstacles, dimensions, text
// annotations, overlays) keeps rendering normally.
let printPlanCaptureInProgress = false;
let selectedPrintPlanGroupKeys = null;
let selectedPrintPlanGroupSignature = '*';
const printPlanGroupSelectionListeners = new Set();

function setPrintPlanCaptureInProgress(value) {
  const previous = printPlanCaptureInProgress;
  printPlanCaptureInProgress = value === true;
  return previous;
}

function restorePrintPlanCaptureInProgress(value) {
  printPlanCaptureInProgress = value === true;
}

function isPrintPlanCaptureInProgress() {
  return printPlanCaptureInProgress === true;
}

function setPrintPlanSelectedGroupKeys(values, options = {}) {
  const previous = selectedPrintPlanGroupKeys === null
    ? null
    : [...selectedPrintPlanGroupKeys];
  const normalized = normalizePrintPlanGroupKeys(values);
  const nextSignature = printPlanGroupSelectionSignature(normalized);
  if (nextSignature === selectedPrintPlanGroupSignature) return previous;
  selectedPrintPlanGroupKeys = normalized === null ? null : new Set(normalized);
  selectedPrintPlanGroupSignature = nextSignature;
  if (options.notify === false) return previous;
  for (const listener of [...printPlanGroupSelectionListeners]) {
    try {
      listener({
        keys: getPrintPlanSelectedGroupKeys(),
        signature: selectedPrintPlanGroupSignature
      });
    } catch (error) {
      console.error('Druckplan-Gruppenfilter konnte nicht aktualisiert werden', error);
    }
  }
  return previous;
}

function restorePrintPlanSelectedGroupKeys(values, options = {}) {
  setPrintPlanSelectedGroupKeys(values, options);
}

function getPrintPlanSelectedGroupKeys() {
  return selectedPrintPlanGroupKeys === null
    ? null
    : new Set(selectedPrintPlanGroupKeys);
}

function getPrintPlanGroupSelectionSignature() {
  return selectedPrintPlanGroupSignature;
}

function isPrintPlanGroupSelected(groupKey) {
  const key = String(groupKey || '').trim();
  if (!key || selectedPrintPlanGroupKeys === null) return true;
  return selectedPrintPlanGroupKeys.has(key);
}

// Product renderers use this stricter helper: the selection must only affect
// the temporary hidden live-plan capture, never the normal plan behind the
// modal while it is open.
function shouldRenderPrintPlanCoreGroup(groupKey) {
  return !isPrintPlanCaptureInProgress() || isPrintPlanGroupSelected(groupKey);
}

function subscribePrintPlanGroupSelection(listener) {
  if (typeof listener !== 'function') return () => { /* nothing subscribed */ };
  printPlanGroupSelectionListeners.add(listener);
  return () => printPlanGroupSelectionListeners.delete(listener);
}

export {
  setPrintPlanCaptureInProgress,
  restorePrintPlanCaptureInProgress,
  isPrintPlanCaptureInProgress,
  setPrintPlanSelectedGroupKeys,
  restorePrintPlanSelectedGroupKeys,
  getPrintPlanSelectedGroupKeys,
  getPrintPlanGroupSelectionSignature,
  isPrintPlanGroupSelected,
  shouldRenderPrintPlanCoreGroup,
  subscribePrintPlanGroupSelection
};
